import { combineLatest, debounceTime, type Observable } from 'rxjs';
import type { ContextShape, FormattingAndLabelRules } from '@ardoq/data-model';
import { LoadedGraphWithViewpointMode } from '@ardoq/graph';
import type { I18nLocale } from '@ardoq/i18n';
import type { Locale } from '@ardoq/locale';
import { context$ } from 'streams/context/context$';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { locale$ } from 'streams/locale$';
import { loadedGraph$ } from 'traversals/loadedGraph$';
import { formattingAndLabelRules$ } from 'streams/filters/formattingAndLabelRules$';
import { DEFAULT_DEBOUNCE_TIME } from 'modelInterface/consts';

export type ViewSourceData = {
  loadedGraph: LoadedGraphWithViewpointMode;
  context: ContextShape;
  locale: Locale;
  i18nLocale: I18nLocale;
  formattingAndLabelRules: FormattingAndLabelRules;
};

export const viewSourceData$: Observable<ViewSourceData> = combineLatest({
  loadedGraph: loadedGraph$,
  context: context$,
  locale: locale$,
  i18nLocale: i18nLocale$,
  formattingAndLabelRules: formattingAndLabelRules$,
}).pipe(debounceTime(DEFAULT_DEBOUNCE_TIME));
